module.exports = __webpack_public_path__ + "static/media/The-West-Subscription_devicecomp_min@2x.eade2693.webp";